import { InjectionToken } from '@angular/core';

import { WorkloadQueryParameter } from './workload-query-parameter.enum';

export const WorkloadQueryParameterToken = new InjectionToken<WorkloadQueryParameter>('WorkloadQueryParameter');
